/**
 * dealers-zip-lookup.js
 * assets/dealers-zip-lookup.js
 *
 * Loads BEFORE request-a-quote.js in theme.liquid.
 *
 * Dealer data is retrieved from the secure Vercel API
 * instead of exposing the complete dealer database.
 */

(function (global) {
  'use strict';

  const API_URL =
    'https://dealer-search-api.vercel.app/api/dealer-search';

  function normalizeDigitsToZip(input) {
    const d = String(input || '').trim().replace(/\D/g, '');

    if (d.length >= 9) return d.slice(0, 5);
    if (d.length === 5) return d;
    if (d.length === 4) return d.padStart(5, '0');

    return '';
  }

  function dealerIsPreferred(value) {
    return (
      value === true ||
      value === 'true' ||
      value === 1 ||
      value === '1'
    );
  }

  global.dealersZipLookup = async function (customerZip) {
    const zip = normalizeDigitsToZip(customerZip);

    if (zip.length !== 5) {
      return null;
    }

    const response = await fetch(
      `${API_URL}?zip=${encodeURIComponent(zip)}`
    );

    if (!response.ok) {
      throw new Error('Dealer lookup failed');
    }

    const data = await response.json();

    if (!Array.isArray(data.results) || !data.results.length) {
      return null;
    }

    const dealer = data.results[0];

    return {
      name: dealer.name || 'Unknown Dealer',
      dealer_id: dealer.dealer_id || '',
      email: dealer.email || '',
      phone: dealer.phone || '',
      zip: dealer.zip || zip,
      city: dealer.city || '',
      state: dealer.state || '',
      url: dealer.url || '',
      preferred: dealerIsPreferred(dealer.preferred),
    };
  };

})(window);